(() => {
  function init() {
    const row = document.getElementById('tt-product-help');
    const dialog = document.getElementById('tt-product-question');
    const details = document.querySelector('[data-testid="product-information-details"]');
    const price = details?.querySelector('product-price, .product-price, [class*="__price"]');
    if (!row || !dialog || !price || !dialog.show || window.self !== window.top) return;
    price.insertAdjacentElement('afterend', row);
    row.hidden = false;
    const trigger = row.querySelector('.tt-product-help__ask');
    const close = dialog.querySelector('.tt-product-question__close');
    const form = dialog.querySelector('form');
    const fields = dialog.querySelector('[data-question-fields]');
    const status = dialog.querySelector('[data-question-status]');
    const send = dialog.querySelector('.tt-product-question__send');
    const verify = dialog.querySelector('[data-question-verify]');
    const variants = dialog.querySelector('[data-question-variants]');
    const backdrop = document.querySelector('.tt-product-question-backdrop');
    const responseFrame = document.createElement('iframe');
    responseFrame.name = 'tt-question-response';
    responseFrame.title = 'Question submission result';
    responseFrame.hidden = true;
    responseFrame.setAttribute('sandbox', 'allow-forms allow-same-origin');
    document.body.append(responseFrame);
    form.target = responseFrame.name;
    const inertElements = new Map();
    let busy = false;
    let nativeSubmit = false;
    let waitingTimer;
    const storageKey = `tt-question-${dialog.dataset.productId}`;
    const field = name => form.elements.namedItem(name);
    function context() {
      const selectedId = document.querySelector('[data-testid="product-information-details"] product-form-component input[name="id"]')?.value
        || new URL(location.href).searchParams.get('variant') || variants.value;
      const option = [...variants.options].find(option => option.value === selectedId);
      const title = option?.textContent || '';
      field('contact[Variant ID]').value = option?.value || '';
      field('contact[Variant]').value = title;
      const url = new URL(dialog.dataset.productUrl, location.origin);
      if (option) url.searchParams.set('variant', option.value);
      field('contact[Product URL]').value = url.href;
      field('return_to').value = url.pathname + url.search + '#tt-product-question';
    }
    function open() {
      context();
      if (!dialog.open) {
        // Keep Shopify's external CAPTCHA interactive above this dialog.
        for (const element of document.body.children) {
          if (element === dialog || element === backdrop || element === responseFrame ||
              /^(SCRIPT|STYLE|LINK)$/.test(element.tagName) ||
              element.id === 'shop-hcaptcha-badge-container' ||
              element.querySelector('iframe[src*="hcaptcha"]')) continue;
          inertElements.set(element, element.inert);
          element.inert = true;
        }
        dialog.show();
      }
      backdrop.hidden = false;
      document.documentElement.classList.add('tt-question-open');
      close.focus({ preventScroll: true });
    }
    trigger.addEventListener('click', open);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      backdrop.hidden = true;
      for (const [element, wasInert] of inertElements) element.inert = wasInert;
      inertElements.clear();
      document.documentElement.classList.remove('tt-question-open');
      trigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); dialog.close(); }
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button, input:not([type="hidden"]), textarea, a[href]')]
        .filter(element => !element.disabled && element.getClientRects().length);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    function clearDraft() { try { sessionStorage.removeItem(storageKey); } catch {} }
    function saveDraft() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ body: field('contact[body]').value, email: field('contact[email]').value, time: Date.now() })); } catch {}
    }
    function finish() {
      clearTimeout(waitingTimer);
      busy = false;
      send.disabled = false;
      field('contact[body]').readOnly = false;
      field('contact[email]').readOnly = false;
    }
    function success() {
      fields.hidden = true;
      let message = dialog.querySelector('[data-question-result="success"]');
      if (!message) {
        message = document.createElement('p');
        message.className = 'tt-product-question__success';
        message.setAttribute('role', 'status');
        message.dataset.questionResult = 'success';
        message.textContent = 'Question sent. I’ll reply by email.';
        fields.before(message);
      }
      field('contact[body]').value = '';
      field('contact[email]').value = '';
      clearDraft();
    }
    function protectedReady() {
      return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('verification')), 30000);
        if (!window.Shopify?.captcha?.protect) {
          clearTimeout(timer);
          reject(new Error('verification'));
          return;
        }
        window.Shopify.captcha.protect(form, () => { clearTimeout(timer); resolve(); });
      });
    }
    responseFrame.addEventListener('load', () => {
      if (!busy) return;
      try {
        const responseUrl = responseFrame.contentWindow.location.href;
        if (responseUrl === 'about:blank') return;
        const html = responseFrame.contentDocument;
        if (html.querySelector('#tt-question-form [data-question-result="success"]')) {
          success();
        } else if (new URL(responseUrl).pathname.includes('/challenge')) {
          status.textContent = 'Shopify needs one more verification. Your question will be kept when you continue.';
          verify.hidden = false;
          send.hidden = true;
        } else {
          const error = html.querySelector('#tt-question-form [data-question-result="error"]');
          status.textContent = error?.textContent.trim() || 'I couldn’t confirm that your question was sent. Your text is still here. Please try again.';
        }
      } catch {
        status.textContent = 'I couldn’t confirm that your question was sent. Your text is still here. Please try again later.';
      }
      finish();
    });
    form.addEventListener('submit', async event => {
      if (nativeSubmit) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || !form.reportValidity()) return;
      if (!field('contact[body]').value.trim()) { field('contact[body]').focus(); return; }
      context();
      busy = true;
      send.disabled = true;
      field('contact[body]').readOnly = true;
      field('contact[email]').readOnly = true;
      verify.hidden = true;
      status.textContent = 'Sending your question… Complete verification if it appears.';
      saveDraft();
      try {
        await protectedReady();
        // Use Shopify's protected submit, which obtains the token before posting.
        // A same-origin response frame keeps the product page and purchase state intact.
        form.submit();
        waitingTimer = setTimeout(() => {
          if (busy) status.textContent = 'This is taking longer than expected. Complete any verification. Your question is still here.';
        }, 60000);
      } catch (error) {
        status.textContent = error.message === 'verification'
          ? 'Verification couldn’t start. Your text is still here. Please try again.'
          : 'I couldn’t confirm that your question was sent. Your text is still here. Please check your connection and try again.';
        finish();
      }
    }, true);
    verify.addEventListener('click', () => {
      context();
      saveDraft();
      form.target = '_self';
      nativeSubmit = true;
      form.requestSubmit();
      nativeSubmit = false;
    });
    if (dialog.querySelector('[data-question-result="success"]')) {
      success();
      open();
    } else {
      try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey));
        if (draft && Date.now() - draft.time < 30 * 60 * 1000) {
          field('contact[body]').value = draft.body;
          field('contact[email]').value = draft.email;
          open();
        }
        clearDraft();
      } catch {}
      if (dialog.querySelector('[data-question-result="error"]')) open();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
